import { render, staticRenderFns } from "./RELOperacao.vue?vue&type=template&id=62e16818&"
import script from "./RELOperacao.vue?vue&type=script&lang=js&"
export * from "./RELOperacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports